<template>
<div class="chapter">
<div class="inner_page">
<h1>Timeline</h1>
<div class="sub_title">
</div>
<table class="noborders" id="imark_B03-timeline.t1">
<thead>
<tr>
<td>
<p id="imark_B03.0"><i><b>World and Cultural Events</b></i></p>
</td>
<td>
<p id="imark_B03.1"><i><b>Sting, Andy Summers, and Stewart Copeland’s Lives and Careers</b></i></p>
</td>
</tr>
</thead>
<tbody>
<tr>
<td>
<p id="imark_B03.2"><b>December 1942</b>: In the midst of World War II, over sixty U-boats are sunk.
                  </p>
</td>
<td>
<p id="imark_B03.3"><b>December 1942</b>: Andrew James Summers is born December 31 at the edge of the river Wyre in Lancashire
                     (Poulton-le-Fylde), near Blackpool, England.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.4"><b>January 1945</b>: The Soviet Red Army liberates the Birkenau and Auschwitz concentration camps.
                  </p>
</td>
<td>
<p id="imark_B03.5"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.6"><b>August 1945</b>: The United States bombs Hiroshima and Nagasaki with atomic weapons. World War II
                     ends soon after.
                  </p>
</td>
<td>
<p id="imark_B03.7"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.8"><b>July 1946</b>: U.S. nuclear testing begins at Bikini Atoll in Micronesia. Sting protests these
                     kinds of experiments with “La Belle Dame Sans Regrets” in 1996.
                  </p>
</td>
<td>
<p id="imark_B03.9"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.10"><b>February 1947</b>: Voice of America begins transmitting into the Soviet Union and its satellites. These
                     broadcasts will influence generations of Eastern European and Russian musicians.
                  </p>
</td>
<td>
<p id="imark_B03.11"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.12"><b>March 1948</b>: Arturo Toscanini, during his television debut, conducts the NBC Symphony, performing
                     the works of Richard Wagner.
                  </p>
</td>
<td>
<p id="imark_B03.13"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.14"><b>April 1950</b>: The Group Areas Acts passes in South Africa, formally segregating the races. By
                     the 1980s, performers will play a number of anti-apartheid shows.
                  </p>
</td>
<td>
<p id="imark_B03.15"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.16"><b>October 1951</b>: <i>I Love Lucy</i> debuts on CBS, and Winston Churchill is re-elected prime minister of the United Kingdom.
                  </p>
</td>
<td>
<p id="imark_B03.17"><b>October 1951</b>: Gordon Matthew Thomas Sumner (Sting) is born in Wallsend, Tyneside, Tyne and Wear,
                     England. His childhood in Wallsend will be the inspiration for multiple songs and
                     even a Broadway show.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.18"><b>July 1952</b>: Mickey Mantle hits his first grand slam.
                  </p>
</td>
<td>
<p id="imark_B03.19"><b>July 1952</b>: Stewart Armstrong Copeland is born in Alexandria, Virginia, on July 16.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.20"><b>April 1953</b>: Frank Sinatra and Nelson Riddle begin their iconic recordings for Capitol Records.
                  </p>
</td>
<td>
<p id="imark_B03.21"><b>1953</b>: The young Andy Summers is listening to AFN radio, which plays American jazz.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.22"><b>May 1954</b>: <i>Brown v. Board of Education of Topeka</i> bans racial segregation in U.S. public schools.
                  </p>
</td>
<td>
<p id="imark_B03.23"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.24"><b>September 1955</b>: <i>Gunsmoke</i>, television’s longest-running western, debuts on CBS. Sting will cite this as one
                     of his favorite programs as a child.
                  </p>
</td>
<td>
<p id="imark_B03.25"><b>1955</b>: Andy Summers is given his first guitar by his uncle Jim. A lodger named David Ellis
                     helps him tune it.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.26"><b>February 1956</b>: Elvis Presley has his first hit with “Heartbreak Hotel.”
                  </p>
</td>
<td>
<p id="imark_B03.27"><b>November 1956</b>: As Queen Elizabeth II rides by, Sting greets her by waving a Union Jack. She waves
                     back.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.28"><b>January 1957</b>: The Cavern Club opens in Liverpool; it will become an early performance venue for
                     The Beatles.
                  </p>
</td>
<td>
<p id="imark_B03.29"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.30"><b>August 1957</b>: <i>American Bandstand </i>premiers.
                  </p>
</td>
<td>
<p id="imark_B03.31"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.32"><b>October 1957</b>: The Soviet Union launches Sputnik 1 into orbit.
                  </p>
</td>
<td>
<p id="imark_B03.33"><b>October 1957</b>: Summers buys a Gibson ES-175 in London.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.34"> </p>
</td>
<td>
<p id="imark_B03.35"><b>1958</b>: Summers buys a Gibson ES-335. Eventually, there will be an Andy Summers signature
                     model of this guitar.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.36"> </p>
</td>
<td>
<p id="imark_B03.37"><b>July 1958</b>: The U.S. Marines land in Beirut, Lebanon, to protect the existing pro-Western government.
                     The Copeland family will leave for London soon after.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.38"><b>April 1960</b>: <i>Ben-Hur </i>wins a number of Academy Awards, including Best Picture. Stewart Copeland will premiere
                     a live-performance score for an earlier film version of <i>Ben-Hur </i>in 2014.
                  </p>
</td>
<td>
<p id="imark_B03.39"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.40"><b>August 1961</b>: Construction of the Berlin Wall begins.
                  </p>
</td>
<td>
<p id="imark_B03.41"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.42"><b>August 1962</b>: President Kennedy orders a blockade of Cuba in order to prevent the establishment
                     of Soviet missile bases.
                  </p>
</td>
<td>
<p id="imark_B03.43"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.44"> </p>
</td>
<td>
<p id="imark_B03.45"><b>1964</b>: Andy Summers joins Zoot Money’s Big Roll Band.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.46"> </p>
</td>
<td>
<p id="imark_B03.47"><b>December 1965</b>: Sting attends The Beatles’ arrival at Newcastle City Hall.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.48"> </p>
</td>
<td>
<p id="imark_B03.49"><b>March 1967</b>: Sting attends a concert by The Jimi Hendrix Experience at Club A’ Go Go in Newcastle.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.50"> </p>
</td>
<td>
<p id="imark_B03.51"><b>July 1967</b>: Summers, along with musicians from Zoot Money’s Big Roll Band, creates Dantalian’s
                     Chariot, a contemporary psychedelic band.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.52"><b>August 1967</b>: Brian Epstein, manager for The Beatles, dies.
                  </p>
</td>
<td>
<p id="imark_B03.53"><b>August 1967</b>: Copeland attends a concert by The Jimi Hendrix Experience at the Saville Theatre
                     in London.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.54"> </p>
</td>
<td>
<p id="imark_B03.55"><b>May 1968</b>: Summers joins the early progressive rock group, Soft Machine.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.56"> </p>
</td>
<td>
<p id="imark_B03.57"><b>July 1968</b>: Summers is dismissed from Soft Machine.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.58"> </p>
</td>
<td>
<p id="imark_B03.59"><b>August 1968</b>: Summers travels to California and joins Eric Burdon and The Animals.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.60"> </p>
</td>
<td>
<p id="imark_B03.61"><b>October 1968</b>: Summers jams with Jimi Hendrix at TTG Studios in Hollywood, California.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.62"><b>January 1969</b>: The first Led Zeppelin album is released; The Beatles give their last public performance.
                  </p>
</td>
<td>
<p id="imark_B03.63"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.64"><b>July 1969</b>: Neil Armstrong becomes first man to walk on the moon.
                  </p>
</td>
<td>
<p id="imark_B03.65"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.66"><b>August 1969</b>: Woodstock Music Festival takes place.
                  </p>
</td>
<td>
<p id="imark_B03.67"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.68"><b>December 1969</b>: Tragic Rolling Stones’ show at Altamont Raceway takes place.
                  </p>
</td>
<td>
<p id="imark_B03.69"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.70"><b>April 1970</b>: The first Earth Day is celebrated in the United States. In the following decade,
                     Sting will become an advocate for environmentalism.
                  </p>
</td>
<td>
<p id="imark_B03.71"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.72"><b>September 1970</b>: Jimi Hendrix dies in London of drug-related complications.
                  </p>
</td>
<td>
<p id="imark_B03.73"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.74"><b>March 1971</b>: Paul Simon’s “Bridge over Troubled Water” wins a Grammy Award for Song of the Year.
                     Sting will tour with Simon forty-three years later.
                  </p>
</td>
<td>
<p id="imark_B03.75"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.76"><b>March 1972</b>: Northern Ireland is occupied by Britain. The resulting unrest will inspire “Invisible
                     Sun.”
                  </p>
</td>
<td>
<p id="imark_B03.77"><b>1972</b>: Along with keyboardist Gerry Richardson, Sting joins Earthrise.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.78"><b>November 1972</b>: Atari introduces the arcade version of <i>Pong,</i> the first video game. Stewart Copeland will write the music for the video game <i>Spyro the Dragon</i> in 1998.
                  </p>
</td>
<td>
<p id="imark_B03.79"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.80"><b>January </b><b>1973</b>: A ceasefire is signed in Vietnam. Ian Copeland, Stewart Copeland’s brother, had
                     fought in the war.
                  </p>
</td>
<td>
<p id="imark_B03.81"><b>1973</b>: Sting joins the Phoenix Jazzmen, a traditional jazz group from which he earns his
                     nickname.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.82"><b>February 1973</b>: <i>The Harder They Come</i>, starring Jimmy Cliff, increases the visibility of reggae in the United States.
                  </p>
</td>
<td>
<p id="imark_B03.83"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.84"> </p>
</td>
<td>
<p id="imark_B03.85"><b>May 1973</b>: Stewart Copeland is the tour manager for Joan Armatrading’s UK tour.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.86"> </p>
</td>
<td>
<p id="imark_B03.87"><b>November 1973</b>: Andy Summers returns to London.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.88"><b>May 1974</b>: India becomes the world’s sixth nuclear power. The Police will perform in India
                     during their 1980 world tour.
                  </p>
</td>
<td>
<p id="imark_B03.89"><b>1974</b>: Summers begins touring with actor and singer David Essex, Neil Sedaka, and Kevin
                     Coyne.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.90"><b>August 1974</b>: President Richard Nixon resigns.
                  </p>
</td>
<td>
<p id="imark_B03.91"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.92"> </p>
</td>
<td>
<p id="imark_B03.93"><b>October 1974</b>: Last Exit begins rehearsing.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.94"> </p>
</td>
<td>
<p id="imark_B03.95"><b>December 1974</b>: Copeland becomes the tour manager, and later drummer, for the progressive rock band,
                     Curved Air.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.96"><b>October 1975</b>: <i>Saturday Night Live</i> premieres with George Carlin as host. Sting will perform on <i>SNL</i> multiple times.
                  </p>
</td>
<td>
<p id="imark_B03.97"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.98"><b>November 1976</b>: Jimmy Carter is elected president of the United States.
                  </p>
</td>
<td>
<p id="imark_B03.99"><b>1976</b>: Curved Air records <i>Airbourne</i> with Stewart Copeland. Summers begins performing with Kevin Ayers.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.100"> </p>
</td>
<td>
<p id="imark_B03.101"><b>December 1976</b>: Copeland meets Sting after a Curved Air concert and gives him his phone number.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.102"> </p>
</td>
<td>
<p id="imark_B03.103"><b>January 1977</b>: Sting moves to London with his wife and child. By mid-January, Sting, Copeland,
                     and Henry Padovani are rehearsing.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.104"><b>April 1977</b>: The legendary disco club, Studio 54, opens in New York City.
                  </p>
</td>
<td>
<p id="imark_B03.105"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.106"> </p>
</td>
<td>
<p id="imark_B03.107"><b>May 1977</b>: Andy Summers performs with Copeland and Sting in Strontium 90. Also, The Police,
                     with Henry Padovani, release the single “Fall Out/Nothing Achieving.”
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.108"> </p>
</td>
<td>
<p id="imark_B03.109"><b>July 1977</b>: Andy Summers performs with The Police for the first time.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.110"><b>August 1977</b>: Elvis Presley dies at Graceland.
                  </p>
</td>
<td>
<p id="imark_B03.111"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.112"><b>September 1977</b>: South African activist Steve Biko dies in police custody.
                  </p>
</td>
<td>
<p id="imark_B03.113"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.114"><b>October 1977</b>: <i>Never Mind the Bollocks, Here’s the Sex Pistols</i> is released on A&amp;M Records. This company will also release all of The Police albums.
                  </p>
</td>
<td>
<p id="imark_B03.115"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.116"> </p>
</td>
<td>
<p id="imark_B03.117"><b>February 1978</b>: The Police bleach their hair for a Wrigley’s Spearmint chewing gum commercial. Their
                     blonde hair will be a definitive part of their image.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.118"> </p>
</td>
<td>
<p id="imark_B03.119"><b>October 1978</b>: The Police begin their first U.S. tour.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.120"> </p>
</td>
<td>
<p id="imark_B03.121"><b>November 1978</b>: <i>Outlandos d’Amour</i> is released on A&amp;M Records.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.122"><b>March 1979</b>: The nuclear power plant at Three Mile Island, Pennsylvania, has an accidental release
                     of radiation.
                  </p>
</td>
<td>
<p id="imark_B03.123"><b>March 1979</b>: The Police begin their second U.S. tour.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.124"><b>May 1979</b>: Conservative politician Margaret Thatcher becomes new prime minister. Her conservative
                     policies will draw the ire of many British performers, including Sting.
                  </p>
</td>
<td>
<p id="imark_B03.125"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.126"> </p>
</td>
<td>
<p id="imark_B03.127"><b>October 1979</b>: <i>Reggatta de Blanc</i> is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.128"><b>December 1979</b>: The Soviet Union invades Afghanistan.
                  </p>
</td>
<td>
<p id="imark_B03.129"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.130"><b>April 1980</b>: A helicopter and a cargo plane collide in a disastrous attempt to rescue American
                     hostages in Tehran.
                  </p>
</td>
<td>
<p id="imark_B03.131"><b>1980</b>: The Police are filmed during a world tour, which will result in <i>The Police: Around the World</i>.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.132"> </p>
</td>
<td>
<p id="imark_B03.133"><b>October 1980</b>: <i>Zenyatta Mondatta</i> is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.134"><b>November 1980</b>: Ronald Reagan is elected president of the United States.
                  </p>
</td>
<td>
<p id="imark_B03.135"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.136"><b>December 1980</b>: John Lennon is shot in New York City.
                  </p>
</td>
<td>
<p id="imark_B03.137"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.138"><b>August 1981</b>: MTV premieres with the Buggles’ “Video Killed the Radio Star.”
                  </p>
</td>
<td>
<p id="imark_B03.139"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.140"> </p>
</td>
<td>
<p id="imark_B03.141"><b>September 1981</b>: Sting performs at the Theatre Royal for Amnesty International. Sting sings “Roxanne,”
                     “Message in a Bottle,” and leads a performance of “I Shall Be Released” as a closing
                     number. This is Sting’s introduction to Amnesty International.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.142"> </p>
</td>
<td>
<p id="imark_B03.143"><b>October 1981</b>: <i>Ghost in the Machine</i> is released. It hits No. 2 in the United States.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.144"> </p>
</td>
<td>
<p id="imark_B03.145"><b>1982</b>: Stewart Copeland begins recording the soundtrack to <i>Rumble Fish</i>. His work will be nominated for a Golden Globe Award.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.146"> </p>
</td>
<td>
<p id="imark_B03.147"><b>October 1982</b>: Andy Summers/Robert Fripp’s <i>I Advance Masked</i> is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.148"><b>November 1982</b>: Michael Jackson’s <i>Thriller</i> debuts.
                  </p>
</td>
<td>
<p id="imark_B03.149"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.150"><b>March 1983</b>: The first compact discs are sold in North America and Europe.
                  </p>
</td>
<td>
<p id="imark_B03.151"><b>1983</b>: Summers publishes a photography book titled <i>Throb</i>.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.152"><b>June 1983</b>: Famine in Ethiopia begins reaching epic proportions.
                  </p>
</td>
<td>
<p id="imark_B03.153"><b>June 1983</b>: <i>Synchronicity </i>is released. It will be The Police’s best-selling album and one of the most iconic
                     albums of the 1980s.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.154"> </p>
</td>
<td>
<p id="imark_B03.155"><b>August 1983</b>: The Police perform at Shea Stadium, and Sting proclaims, “This is it.”
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.156"><b>October 1983</b>: The United States invades Grenada.
                  </p>
</td>
<td>
<p id="imark_B03.157"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.158"> </p>
</td>
<td>
<p id="imark_B03.159"><b>March 1984</b>: The Police complete their final world tour in Melbourne, Australia (until their
                     reunion).
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.160"><b>May 1984</b>: The Soviet Union withdraws from the Olympic Games.
                  </p>
</td>
<td>
<p id="imark_B03.161"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.162"> </p>
</td>
<td>
<p id="imark_B03.163"><b>September 1984</b>: Andy Summers/Robert Fripp’s <i>Bewitched</i> is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.164"><b>November 1984</b>: Bob Geldof’s Band Aid releases “Do They Know It’s Christmas?” in an attempt to aid
                     starving Ethiopians. Sting participates in the recording.
                  </p>
</td>
<td>
<p id="imark_B03.165"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.166"><b>March 1985</b>: USA for Africa debuts “We Are the World.”
                  </p>
</td>
<td>
<p id="imark_B03.167"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.168"> </p>
</td>
<td>
<p id="imark_B03.169"><b>May 1985</b>: Filming begins for <i>Bring on the Night</i>, a documentary promoting Sting’s new solo career.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.170"> </p>
</td>
<td>
<p id="imark_B03.171"><b>June 1985</b>: Sting’s first solo album, <i>The Dream of the Blue Turtles</i>, is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.172"> </p>
</td>
<td>
<p id="imark_B03.173"><b>July 1985</b>: Sting performs at Live Aid. He performs with only Branford Marsalis on saxophone.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.174"><b>October 1985</b>: Terrorists hijack the <i>Achille Lauro</i>, an Italian cruise liner.
                  </p>
</td>
<td>
<p id="imark_B03.175"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.176"> </p>
</td>
<td>
<p id="imark_B03.177"><b>November 1985</b>: <i>Every Breath You Take: The Singles</i>, a compilation album, is released. It features “Don’t Stand so Close to Me ’86,”
                     a maligned remake of the original.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.178"><b>January 1986</b>: The space shuttle <i>Challenger</i> explodes.
                  </p>
</td>
<td>
<p id="imark_B03.179"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.180"><b>April 1986</b>: The Chernobyl nuclear accident occurs in the Soviet Union.
                  </p>
</td>
<td>
<p id="imark_B03.181"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.182"> </p>
</td>
<td>
<p id="imark_B03.183"><b>June 1986</b>: The Police perform three shows for the Conspiracy of Hope Tour. These will be their
                     last performances until 2003.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.184"> </p>
</td>
<td>
<p id="imark_B03.185"><b>July 1986</b>: Sting’s excellent live album, <i>Bring on the Night, </i>debuts. It features inventive arrangements and superlative performances of his greatest
                     hits.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.186"><b>November 1986</b>: An American secret initiative is discovered, revealing the diversion of funds from
                     arms sales to Nicaraguan Contras. Sting will later write “Fragile,” inspired by the
                     death of an American civil engineer killed by the Contras in 1987.
                  </p>
</td>
<td>
<p id="imark_B03.187"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.188"><b>January 1987</b>: Aretha Franklin is the first woman to be inducted into the Rock and Roll Hall of
                     Fame. The Police will be inducted in 2003.
                  </p>
</td>
<td>
<p id="imark_B03.189"><b>1987</b>: Andy Summers’s <i>XYZ</i> is released. Summers’s attempt at mainstream success does not attain critical or
                     commercial acceptance.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.190"><b>June 1987</b>: An Iranian airliner is shot down by a U.S. Navy ship in the Persian Gulf.
                  </p>
</td>
<td>
<p id="imark_B03.191"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.192"> </p>
</td>
<td>
<p id="imark_B03.193"><b>October 1987</b>: Sting’s . . . <i>Nothing Like the Sun</i> debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.194"> </p>
</td>
<td>
<p id="imark_B03.195"><b>November 1987</b>: Sting meets Jean-Pierre Dutilleux and flies to the Xingu reservation to meet Chief
                     Raoni.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.196"> </p>
</td>
<td>
<p id="imark_B03.197"><b>December 1987</b>: The film <i>Wall Street</i> is released, featuring a soundtrack written by Stewart Copeland.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.198"><b>January 1988</b>: Broadway’s longest-running show, <i>The Phantom of the Opera</i>, opens. Sting will attempt his own Broadway show in 2014.
                  </p>
</td>
<td>
<p id="imark_B03.199"><b>1988</b>: Andy Summers debuts <i>Mysterious Barricades</i>.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.200"><b>August 1988</b>: Al-Qaeda is formed by Osama bin Laden.
                  </p>
</td>
<td>
<p id="imark_B03.201"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.202"> </p>
</td>
<td>
<p id="imark_B03.203"><b>November 1988</b>: Stewart Copeland’s ballet, <i>Emilio</i>, debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.204"><b>December 1988</b>: Pan Am 747 is destroyed from a terrorist bomb, crashing in Lockerbie, Scotland.
                     Nearly three hundred people are killed.
                  </p>
</td>
<td>
<p id="imark_B03.205"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.206"><b>March 1989</b>: The <i>Exxon Valdez</i> spills 11 million gallons of oil into Alaska’s Prince William Sound.
                  </p>
</td>
<td>
<p id="imark_B03.207"><b>1989</b>: Andy Summers releases <i>The Golden Wire.</i></p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.208"> </p>
</td>
<td>
<p id="imark_B03.209"><b>April 1989</b>: Sting and Chief Raoni meet Pope John Paul II at the Vatican. Raoni and Sting had
                     conducted a series of press conferences to draw attention to issues in the Amazonian
                     rain forest.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.210"> </p>
</td>
<td>
<p id="imark_B03.211"><b>October 1989</b>: Stewart Copeland’s new band, Animal Logic, releases <i>Animal Logic. </i>His <i>Holy Blood and Crescent Moon</i> debuts in Cleveland as well.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.212"><b>November 1989</b>: The Berlin Wall falls.
                  </p>
</td>
<td>
<p id="imark_B03.213"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.214"><b>December 1989</b>: <i>The Simpsons </i>premieres. Sting will help sing “We’re Sending Our Love Down the Well” in 1992. The
                     part was originally offered to Bruce Springsteen.
                  </p>
</td>
<td>
<p id="imark_B03.215"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.216"><b>February 1990</b>: Nelson Mandela is freed after twenty-seven years in prison.
                  </p>
</td>
<td>
<p id="imark_B03.217"><b>1990</b>: Summers’s <i>Charming Snakes</i> debuts. The album is steeped in contemporary jazz fusion.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.218"><b>August 1990</b>: Kuwait is invaded by Iraqi forces, which will draw the United States into the conflict.
                  </p>
</td>
<td>
<p id="imark_B03.219"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.220"><b>November 1990</b>: Margaret Thatcher resigns as British Prime Minister.
                  </p>
</td>
<td>
<p id="imark_B03.221"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.222"> </p>
</td>
<td>
<p id="imark_B03.223"><b>January 1991</b>: Sting’s <i>Soul Cages</i> is released to mixed reviews. The album is more introspective than most listeners
                     expect from a Sting album.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.224"> </p>
</td>
<td>
<p id="imark_B03.225"><b>July 1991</b>: Animal Logic releases their final album, <i>Animal Logic II</i>.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.226"> </p>
</td>
<td>
<p id="imark_B03.227">August 1991: Summers’s <i>World Gone Strange</i> debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.228"><b>September 1991</b>: Nirvana’s single, “Smells Like Teen Spirit,” is released. The drummer is Dave Grohl,
                     who, with the Foo Fighters, will host Stewart Copeland during a tour in 2008.
                  </p>
</td>
<td>
<p id="imark_B03.229"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.230"><b>April </b><b>1992</b>: A tribute to Freddie Mercury is held at Wembley Stadium, raising millions for AIDS
                     research.
                  </p>
</td>
<td>
<p id="imark_B03.231"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.232"><b>November 1992</b>: Bill Clinton is elected 42nd president of the United States.
                  </p>
</td>
<td>
<p id="imark_B03.233"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.234"> </p>
</td>
<td>
<p id="imark_B03.235"><b>1993</b>: <i>Invisible Threads</i> with John Etheridge and Andy Summers is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.236"> </p>
</td>
<td>
<p id="imark_B03.237"><b>March 1993</b>: <i>Ten Summoner’s Tales </i>debuts to rave reviews.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.238"> </p>
</td>
<td>
<p id="imark_B03.239"><b>September 1993</b>: <i>Message in a Box</i> is released. This box set contains the majority of The Police’s studio recordings.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.240"><b>February 1994</b>: Steve Fossett becomes the first person to make a solo flight across the Pacific
                     Ocean in a balloon.
                  </p>
</td>
<td>
<p id="imark_B03.241"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.242"><b>April 1994</b>: Kurt Cobain commits suicide by a self-inflicted gunshot.
                  </p>
</td>
<td>
<p id="imark_B03.243"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.244"><b>August 1994</b>: A cease-fire is declared by the IRA in Northern Ireland.
                  </p>
</td>
<td>
<p id="imark_B03.245"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.246"><b>October 1994</b>: Pope John Paul II visits the United States.
                  </p>
</td>
<td>
<p id="imark_B03.247"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.248"><b>April 1995</b>: The Alfred P. Murrah Federal Building in Oklahoma City is bombed.
                  </p>
</td>
<td>
<p id="imark_B03.249"><b>1995</b>: Andy Summers’s <i>Synaesthesia</i> is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.250"> </p>
</td>
<td>
<p id="imark_B03.251"><b>June 1995</b>: <i>The Police Live!</i> is released. This excellent double album features performances from 1979 and 1983.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.252"><b>February 1996</b>: World chess champion, Garry Kasparov, loses a game to the chess computer “Deep Blue”
                     for the first time. In 2000, Sting and four bandmates will lose to Kasparov within
                     fifty minutes.
                  </p>
</td>
<td>
<p id="imark_B03.253"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.254"> </p>
</td>
<td>
<p id="imark_B03.255"><b>March 1996</b>: Sting’s <i>Mercury Falling</i> debuts. It features “I’m So Happy I Can’t Stop Crying,” which would be a hit for
                     Toby Keith in late 1997.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.256"><b>July 1997</b>: Gianni Versace is killed outside his home in Miami, Florida, by Andrew Cunanan.
                     Sting will attend his memorial in Milan.
                  </p>
</td>
<td>
<p id="imark_B03.257"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.258"><b>August 1997</b>: Princess Diana is killed in a car accident.
                  </p>
</td>
<td>
<p id="imark_B03.259"><b>August 1997</b>: <i>Strontium 90: Police Academy</i> is released. This album features a performance in Paris on May 28, 1977, of Mike
                     Howlett, Copeland, Sting, and Summers, collectively known as Strontium 90. This was
                     the first time that Summers had performed with Sting and Copeland. After this concert,
                     they changed their name to the Elevators, but after a couple more performances, they
                     disbanded.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.260"><b>May 1998</b>: Bear Grylls becomes the youngest British climber to scale Mount Everest at twenty-three.
                  </p>
</td>
<td>
<p id="imark_B03.261"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.262"> </p>
</td>
<td>
<p id="imark_B03.263"><b>September 1998</b>: <i>Spyro the Dragon</i> is released, featuring music from Stewart Copeland.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.264"><b>April 1999</b>: Twelve students and a teacher are murdered at Columbine High School in Littleton,
                     Colorado.
                  </p>
</td>
<td>
<p id="imark_B03.265"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.266"> </p>
</td>
<td>
<p id="imark_B03.267"><b>May 1999</b>: Andy Summers’s tribute to Thelonious Monk, <i>Green Chimneys: The Music of Thelonious Monk</i>, debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.268"> </p>
</td>
<td>
<p id="imark_B03.269"><b>September 1999</b>: Sting’s <i>Brand New Day</i> is released. With the help of a Jaguar commercial, “Desert Rose” becomes a worldwide
                     hit.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.270"> </p>
</td>
<td>
<p id="imark_B03.271"><b>May 2000</b>: Stewart Copeland performs with Oysterhead at the New Orleans Jazz &amp; Heritage Festival.
                     He has to adjust to the improvisational nature of the group.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.272"> </p>
</td>
<td>
<p id="imark_B03.273"><b>September 2000</b>: Andy Summers’s tribute to Charles Mingus, <i>Peggy’s Blue Skylight</i>, debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.274"><b>October 2000</b>: The USS <i>Cole</i> is damaged by terrorists.
                  </p>
</td>
<td>
<p id="imark_B03.275"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.276"><b>February 2001</b>: U2 wins a Grammy Award for Song of the Year for “Beautiful Day.”
                  </p>
</td>
<td>
<p id="imark_B03.277"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.278"><b>September 2001</b>: New York City’s World Trade Center and the Pentagon are attacked by the Al-Qaeda
                     terrorist organization on September 11. A fourth hijacked plane crashes outside of
                     Pittsburgh. A live performance by Sting takes place that same evening. He dedicates
                     the resulting album to the victims of the attacks.
                  </p>
</td>
<td>
<p id="imark_B03.279"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.280"> </p>
</td>
<td>
<p id="imark_B03.281"><b>October 2001</b>: Oysterhead’s <i>The Grand Pecking Order</i> debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.282"><b>November 2002</b>: George W. Bush signs the Homeland Security Act, establishing the Department of Homeland
                     Security.
                  </p>
</td>
<td>
<p id="imark_B03.283"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.284"><b>March 2003</b>: Britain and the United States invade Iraq.
                  </p>
</td>
<td>
<p id="imark_B03.285"><b>March 2003</b>: The Police are inducted into the Rock and Roll Hall of Fame.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.286"> </p>
</td>
<td>
<p id="imark_B03.287"><b>August 2003</b>: Copeland performs at La Notte della Taranta Festival.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.288"> </p>
</td>
<td>
<p id="imark_B03.289"><b>September 2003</b>: Sting’s <i>Sacred Love</i> debuts. Sting will look toward other musical challenges after this album is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.290"> </p>
</td>
<td>
<p id="imark_B03.291"><b>October 2003</b>: Sting publishes his autobiography, <i>Broken Music</i>. Although he avoids discussing his time with The Police, reviews are positive.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.292"><b>December 2003</b>: American troops capture Saddam Hussein.
                  </p>
</td>
<td>
<p id="imark_B03.293"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.294"><b>February 2004</b>: Justin Timberlake rips off the bodice of Janet Jackson’s costume during the halftime
                     show of Super Bowl XXXVIII. Sting and No Doubt had performed at the Super Bowl halftime
                     show the previous year.
                  </p>
</td>
<td>
<p id="imark_B03.295"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.296"> </p>
</td>
<td>
<p id="imark_B03.297"><b>March 2004</b>: Summers’s <i>Earth + Sky</i> debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.298"><b>April 2005</b>: Benedict XVI becomes the pope after the death of John Paul II.
                  </p>
</td>
<td>
<p id="imark_B03.299"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.300"> </p>
</td>
<td>
<p id="imark_B03.301"><b>June 2005</b>: Copeland releases the CD/DVD version of <i>Orchestralli</i>, a live version of his chamber music.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.302"><b>August 2005</b>: Hurricane Katrina destroys parts of the Gulf Coast and New Orleans.
                  </p>
</td>
<td>
<p id="imark_B03.303"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.304"><b>February 2006</b>: Another punk trio, Green Day, wins a Grammy Award for Record of the Year for “Boulevard
                     of Broken Dreams.”
                  </p>
</td>
<td>
<p id="imark_B03.305"><b>September 2006</b>: Stewart Copeland’s <i>Everyone Stares: The Police Inside Out</i> is released on DVD. Copeland had filmed much of the behind-the-scenes action of The
                     Police on tour. The documentary details the energy and chaos surrounding the group.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.306"> </p>
</td>
<td>
<p id="imark_B03.307"><b>October 2006</b>: Andy Summers’s autobiography, <i>One Train Later</i>, is released to positive reviews. Summers’s pre-Police stories are particularly amusing.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.308"> </p>
</td>
<td>
<p id="imark_B03.309"><b>October 2006</b>: Sting’s Renaissance album, <i>Songs from the Labyrinth</i>, debuts. Sting sings songs written by the Renaissance lutenist/songwriter, John Dowland.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.310"> </p>
</td>
<td>
<p id="imark_B03.311"><b>May 2007</b>: The Police reunite and begin a record-breaking world tour.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.312"><b>June 2007</b>: Tony Blair is replaced by Gordon Brown as prime minister of Great Britain.
                  </p>
</td>
<td>
<p id="imark_B03.313"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.314"> </p>
</td>
<td>
<p id="imark_B03.315"><b>August 2007</b>: Summers’s album with Ben Verdery, <i>First You Build a Cloud, </i>debuts. Also, an excellent compilation of Copeland’s work, <i>The Stewart Copeland Anthology</i>, is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.316"> </p>
</td>
<td>
<p id="imark_B03.317"><b>March 2008</b>: Copeland premieres his orchestral work, “Celeste,” in Savannah, Georgia.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.318"><b>November 2008</b>: Barack Obama is elected the 44th president of the United States.
                  </p>
</td>
<td>
<p id="imark_B03.319"><b>November 2008</b>: <i>Certifiable: Live from Buenos Aires</i>, live recordings from The Police’s reunion tour, is released.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.320"> </p>
</td>
<td>
<p id="imark_B03.321"><b>July 2009</b>: Sting publishes a collection of his lyrics, aptly titled <i>Lyrics by Sting</i>. Short backgrounds are offered, and the lyrics are presented in a remarkably elegant
                     way.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.322"> </p>
</td>
<td>
<p id="imark_B03.323"><b>October 2009</b>: Sting’s collection of folk tunes, <i>If on a Winter’s Night . . . </i>, is released. Sting’s interest in winter is integrated throughout the album.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.324"> </p>
</td>
<td>
<p id="imark_B03.325"><b>January 2010</b>: Stewart Copeland’s autobiography, <i>Strange Things Happen</i>, debuts. This autobiography is more a collection of amusing stories than a full-fledged
                     narrative of Copeland’s life.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.326"><b>April 2010</b>: An explosion on a British Petroleum platform off the coast of Louisiana kills eleven
                     people and releases millions of gallons of crude oil into the Gulf of Mexico, making
                     it the world’s largest oil spill of its kind.
                  </p>
</td>
<td>
<p id="imark_B03.327"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.328"> </p>
</td>
<td>
<p id="imark_B03.329"><b>August 2010</b>: Sting’s orchestral album, <i>Symphonicities</i>, debuts. The orchestral arrangements provide an air of sophistication to Sting’s
                     pop compositions.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.330"><b>October 2010</b>: A capsule is used to free the first of thirty-three Chilean miners trapped over
                     a half mile underground. All the miners would be freed within twenty-four hours.
                  </p>
</td>
<td>
<p id="imark_B03.331"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.332"> </p>
</td>
<td>
<p id="imark_B03.333"><b>February 2011</b>: Copeland debuts “Gamelan D’Drum” with the Dallas Symphony Orchestra.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.334"><b>March 2011</b>: Japan is hit by a large earthquake, triggering a tsunami. The resulting tidal surge
                     will destroy a series of nuclear reactors at the Fukushima Daiichi Nuclear Power Station.
                  </p>
</td>
<td>
<p id="imark_B03.335"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.336"><b>April 2011</b>: Prince William and Kate Middleton marry at Westminster Abbey in London.
                  </p>
</td>
<td>
<p id="imark_B03.337"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.338"><b>May 2011</b>: Osama bin Laden is killed in Abbottabad, Pakistan, by U.S. troops.
                  </p>
</td>
<td>
<p id="imark_B03.339"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.340"> </p>
</td>
<td>
<p id="imark_B03.341"><b>August 2011</b>: Copeland participates in David Letterman’s “Drum Solo Week.” Drum aficionados are
                     thrilled to hear Copeland perform a rare drum solo.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.342"> </p>
</td>
<td>
<p id="imark_B03.343"><b>September 2012</b>: Summers’s Brazilian-inspired album <i>Fundamental</i> with Fernanda Takai debuts.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.344"><b>October 2012</b>: Hurricane Sandy strikes New Jersey, New York, and Connecticut, making it the second
                     costliest hurricane in the United States.
                  </p>
</td>
<td>
<p id="imark_B03.345"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.346"><b>December 2012</b>: Adam Lanza kills twenty-six people, including twenty children, at Sandy Hook Elementary
                     School in Newtown, Connecticut.
                  </p>
</td>
<td>
<p id="imark_B03.347"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.348"><b>February 2013</b>: Pope Benedict XVI retires, the first pope to do so since 1415.
                  </p>
</td>
<td>
<p id="imark_B03.349"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.350"> </p>
</td>
<td>
<p id="imark_B03.351"><b>September 2013</b>: The soundtrack to Sting’s Broadway show, <i>The Last Ship</i>, is released. It provides a musical narrative to Sting’s youth.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.352"><b>February 2014</b>: The Ebola epidemic in West Africa begins. Also, Sting and Paul Simon begin a world
                     tour together.
                  </p>
</td>
<td>
<p id="imark_B03.353"> </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.354"> </p>
</td>
<td>
<p id="imark_B03.355"><b>March 2014</b>: Summers’s rock band, Circa Zero, debuts <i>Circus Hero</i>. Summers was inspired by the 2007 reunion to form a new rock band.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.356"> </p>
</td>
<td>
<p id="imark_B03.357"><b>June 2014</b>: Copeland’s percussion concerto, “Poltroons in Paradise,” debuts in Liverpool.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.358"> </p>
</td>
<td>
<p id="imark_B03.359"><b>September 2014</b>: Sting’s <i>The Last Ship</i> premieres on Broadway.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.360"> </p>
</td>
<td>
<p id="imark_B03.361"><b>October 2014</b>: Sting is nominated for solo induction into the Rock and Roll Hall of Fame.
                  </p>
</td>
</tr>
<tr>
<td>
<p id="imark_B03.362"> </p>
</td>
<td>
<p id="imark_B03.363"><b>April 2015</b>: <i>Dare to Drum</i>, a documentary featuring Copeland’s work with the percussion ensemble D’Drum premieres
                     in Dallas, Texas.
                  </p>
</td>
</tr>
</tbody>
</table>
<div class="table_footer"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4B03timeline.vue?746faf38